/* IntegroPet – carrello Kaching nel tema nuovo (caricato da layout/theme.liquid).
   Cosa fa:
   - "Consegna ogni 1 mese/i" diventa "Abbonamento · ogni mese" + "Annulli o sposti quando vuoi"
   - sotto il totale: "Spedizione gratis inclusa" oppure "+ 4,99 € di spedizione · gratis sopra 49 €"
   - sotto i metodi di pagamento: il timer delle 14 (niente weekend) e "Paghi anche in contrassegno"
   Non tocca prezzi, sconti o prodotti: aggiunge solo testi. Se lo togli, il carrello torna come prima. */
(function () {
  'use strict';
  if (window.__ipkcCart) return;
  window.__ipkcCart = true;

  var SHIPPING_COST = '4,99 €';   // costo della spedizione sotto la soglia
  var FREE_FROM = '49 €';         // soglia della spedizione gratis
  var CUTOFF = 14;                // ordini entro le 14 (ora di Roma) partono il giorno stesso, lun-ven
  var EXTRA_LINE = 'Paghi anche in contrassegno';

  var DAYS = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
  var UNITS = {
    'giorno/i': ['giorno', 'giorni'],
    'settimana/e': ['settimana', 'settimane'],
    'mese/i': ['mese', 'mesi'],
    'anno/i': ['anno', 'anni']
  };

  /* "Consegna ogni 2 mese/i" -> "Abbonamento · ogni 2 mesi". Se il testo è diverso dal solito, non tocca niente. */
  function planText(raw) {
    var m = (raw || '').trim().match(/(\d+)\s+(\S+)/);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    var u = UNITS[m[2].toLowerCase()];
    if (!u || !n) return null;
    return 'Abbonamento · ogni ' + (n === 1 ? u[0] : n + ' ' + u[1]);
  }

  /* Ora di Roma, qualunque sia il fuso del telefono del cliente */
  function romeNow() {
    try {
      var out = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short'
      }).formatToParts(new Date()).forEach(function (p) { out[p.type] = p.value; });
      return { y: +out.year, m: +out.month, d: +out.day, h: (+out.hour) % 24, min: +out.minute };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours(), min: n.getMinutes() };
    }
  }

  function isShipDay(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; }

  function timerHtml() {
    var now = romeNow();
    var today = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var mins = now.h * 60 + now.min;
    if (isShipDay(today) && mins < CUTOFF * 60) {
      var left = CUTOFF * 60 - mins;
      var h = Math.floor(left / 60), m = left % 60;
      return 'Ordina entro <strong>' + (h > 0 ? h + ' h ' : '') + m + ' min</strong>: il pacco parte oggi';
    }
    var next = today, i;
    for (i = 1; i < 8; i++) {
      next = new Date(today.getTime() + i * 86400000);
      if (isShipDay(next)) break;
    }
    return 'Ordina ora: il pacco parte <strong>' + (i === 1 ? 'domani' : DAYS[next.getUTCDay()]) + '</strong>';
  }

  function sync(cart) {
    /* 1. Abbonamento */
    var boxes = cart.querySelectorAll('.kaching-cart-item__selling-plan-content');
    for (var b = 0; b < boxes.length; b++) {
      var box = boxes[b];
      var src = box.querySelector('.kaching-cart-item__selling-plan-delivery-policy');
      var mine = box.querySelector('.ipkc-plan');
      var txt = src ? planText(src.textContent) : null;
      if (!txt) {
        if (mine) mine.remove();
        box.classList.remove('ipkc-ok');
        continue;
      }
      if (!mine) {
        mine = document.createElement('div');
        mine.className = 'ipkc-plan';
        box.appendChild(mine);
      }
      if (mine.getAttribute('data-t') !== txt) {
        mine.setAttribute('data-t', txt);
        mine.innerHTML = '';
        mine.appendChild(document.createTextNode(txt));
        var small = document.createElement('small');
        small.textContent = 'Annulli o sposti quando vuoi';
        mine.appendChild(small);
      }
      box.classList.add('ipkc-ok');
    }

    var footer = cart.querySelector('.kaching-cart__footer');

    /* 2. Spedizione sotto il totale (si basa sulla barra della spedizione gratis del carrello) */
    var sub = footer && footer.querySelector('.kaching-cart__subtotal');
    var bar = cart.querySelector('.kaching-cart__tiered-promotions-bar-progress-fill');
    var ship = footer && footer.querySelector('.ipkc-ship');
    if (!sub || !bar) {
      if (ship) ship.remove();
    } else {
      var free = parseFloat(bar.getAttribute('data-progress-percentage') || '0') >= 100;
      var shipTxt = free ? 'Spedizione gratis inclusa' : '+ ' + SHIPPING_COST + ' di spedizione · gratis sopra ' + FREE_FROM;
      if (!ship) {
        ship = document.createElement('p');
        ship.className = 'ipkc-ship';
      }
      if (ship.previousElementSibling !== sub) sub.after(ship);
      if (ship.textContent !== shipTxt) ship.textContent = shipTxt;
      if (ship.classList.contains('ipkc-ship--free') !== free) ship.classList.toggle('ipkc-ship--free', free);
    }

    /* 3. Timer e contrassegno sotto i metodi di pagamento */
    var anchor = footer && (footer.querySelector('.kaching-cart__payment-icons') || footer.querySelector('.kaching-cart__checkout-button'));
    var extra = footer && footer.querySelector('.ipkc-extra');
    if (!anchor) {
      if (extra) extra.remove();
    } else {
      if (!extra) {
        extra = document.createElement('div');
        extra.className = 'ipkc-extra';
      }
      if (extra.previousElementSibling !== anchor) anchor.after(extra);
      var html = '<p>' + timerHtml() + '</p><p>' + EXTRA_LINE + '</p>';
      if (extra.getAttribute('data-h') !== html) {
        extra.setAttribute('data-h', html);
        extra.innerHTML = html;
      }
    }
  }

  /* Il carrello si ridisegna da solo quando cambi qualcosa: ogni volta rimetto i testi (senza ripetere lavoro inutile) */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      var cart = document.getElementById('kaching-cart');
      if (cart) {
        try { sync(cart); } catch (e) { /* in caso di errore il carrello resta com'è */ }
      }
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['data-progress-percentage', 'data-open']
  });
  setInterval(schedule, 30000); /* aggiorna il timer */
  schedule();
})();
